import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import type { LoadedViewBreadcrumb } from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import type { FC } from 'react';
import { unbindView } from '../../commands/unbindView';

export const getLoadedViewBreadcrumbText = (
  breadcrumb: LoadedViewBreadcrumb,
): string => `View: ${breadcrumb.label}`;

export const LoadedViewBreadcrumbItem: FC<
  GraphBreadcrumbProps<LoadedViewBreadcrumb>
> = (props) => {
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  return (
    <GraphBreadcrumbContainer
      containerStyle='extra'
      onRemoveButtonClick={() => {
        ctxProps.dispatch(unbindView);
      }}
      removalIndicated={props.removalIndicated}
    >
      {getLoadedViewBreadcrumbText(props.content)}
    </GraphBreadcrumbContainer>
  );
};
